
export const onServiceWorkerUpdate = (store) => (reg) =>
    store.dispatch({ type: 'SW_UPDATE', payload: reg })